module.exports = __webpack_public_path__ + "assets/b4572049194b9eaf2c245aa444332ecc.png";